import axios from "../../../../api/axios";
import { TrophiesResponse } from "../types/trophies.types";

const TROPHIES_PAGE_LIMIT = 10;

export const getUserTrophies = async (
  userId: string,
  limit: number = TROPHIES_PAGE_LIMIT,
  offset: number = 0
): Promise<TrophiesResponse> => {
  try {
    const response = await axios.get<TrophiesResponse>(`users/${userId}/trophies?offset=${offset}&limit=${limit}`);
    return response.data;
  } catch (err) {
    throw new Error(`Failed to fetch user trophies: ${(err as Error).message}`);
  }
};
